import { handleException } from 'actions/exceptions';
import { ApiService } from '../../services';

export const GET_BATCHES_REQUEST = 'GET_BATCHES_REQUEST';
export const GET_BATCHES_SUCCESS = 'GET_BATCHES_SUCCESS';
export const GET_BATCHES_FAILURE = 'GET_BATCHES_FAILURE';

function requestGetBatches() {
  return {
    type: GET_BATCHES_REQUEST,
    isGettingBatches: true
  };
}

function receiveGetBatches(batches, batchesCount) {
  return {
    type: GET_BATCHES_SUCCESS,
    isGettingBatches: false,
    batches,
    batchesCount
  };
}

function rejectGetBatches() {
  return {
    type: GET_BATCHES_FAILURE,
    isGettingBatches: false
  };
}

export function getBatches(pageNumber, pageSize, sortBy, sortDirection, filters) {
  return (dispatch) => {
    dispatch(requestGetBatches());
    const promise = () => ApiService
      .getBatches(pageNumber, pageSize, sortBy, sortDirection, filters)
      .then((response) => {
        dispatch(receiveGetBatches(response.data.batches, response.data.totalCount));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetBatches, true));
        }
      });
    return promise();
  };
}
